import { Userpilot } from "userpilot";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import { AccountTypeMap } from "lib/AccountType";
import { useDecodedAuthPrincipal } from "AuthPrincipal";

const userpilotAppToken = process.env.REACT_APP_USERPILOT_APP_TOKEN;

export const useUserpilot = () => {
  const [userpilotInit, setUserpilotInit] = useState(false);
  const location = useLocation();
  const principal = useDecodedAuthPrincipal();

  useEffect(() => {
    if (!userpilotInit && userpilotAppToken) {
      Userpilot.initialize(userpilotAppToken);
      setUserpilotInit(true);
    }
  }, [userpilotInit, setUserpilotInit]);

  useEffect(() => {
    // see "Identify users to Userpilot"
    // at https://docs.userpilot.com/article/22-install-userpilot-on-single-page-application-frameworks
    if (userpilotInit && principal) {
      Userpilot.identify(principal.user.id, {
        accountId: principal.account.id,
        accountName: principal.account.name,
        accountType: principal.account.type
          ? AccountTypeMap[principal.account.type]
          : "",
        email: principal.user.email,
        isPro: principal.account.isPro,
        name: principal.user.displayName,
      });
    }
  }, [userpilotInit, principal]);

  useEffect(() => {
    // see "Reload Userpilot on a Page Change"
    // at https://docs.userpilot.com/article/22-install-userpilot-on-single-page-application-frameworks
    if (userpilotInit) {
      Userpilot.reload();
    }
  }, [userpilotInit, location]);
};
